import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import posthog from 'posthog-js';
import { DateTime } from 'luxon';
import FileUpload from './FileUpload.jsx';
import { getFileUploadHistory } from '../../../../libs/fetch.js';

import { useAuthContext } from '../../../../contexts/AuthContext.jsx';

export default function IntegrationCustomerUpload(props) {
  const [fileHistory, setFileHistory] = useState([]);
  const { dataSources, permissions } = props;
  const { organization } = useAuthContext();
  const canEdit = permissions.includes('edit');

  const dataSourceOptions = dataSources.map((source) => ({
    value: source.connection_data_source_id,
    label: source.name,
  }));

  const [selectedDataSource, setSelectedDataSource] = useState(dataSourceOptions[0] || null);

  const columns = [{
    name: 'File Name',
    selector: row => row.file_name,
    wrap: true,
  },
  {
    name: 'Uploaded At',
    selector: row => DateTime.fromISO(row.uploaded_at).toLocaleString(DateTime.DATETIME_MED),
  },
  {
    name: 'Uploaded By',
    selector: row => row.uploaded_by,
  },
  {
    name: 'Status',
    selector: row => row.status,
  }
  ];

  const fetchFileHistory = async () => {
    try {
      const fh = await getFileUploadHistory(selectedDataSource?.value);
      setFileHistory(fh?.data || []);
    } catch (error) {
      console.error('Error fetching data:', error);
      setError(error);
    }
  };

  useEffect(() => {
    if (selectedDataSource?.value) {
      fetchFileHistory();
    }
    posthog.capture('$pageview');
  }, [selectedDataSource]);


  const handleSelectChange = (selectedOption) => {
    setSelectedDataSource(selectedOption);
  };

  const handleSupportClick = () => {
    if (window.Intercom) {
      window.Intercom('showNewMessage');
    } else {
      console.warn('Intercom is not initialized');
    }
  };

  return (
    <div>
      <div className="px-4 sm:px-0">
        <h3 className="mt-5 text-base font-semibold leading-7 text-gray-900">
          Manual File Upload
        </h3>
      </div>

      <div className="mt-3 border-t border-gray-100">
        <dl className="divide-y divide-gray-100">
          <div className="px-4 py-6 sm:grid sm:grid-cols-8 sm:gap-4 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Select Data Source
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
              <Select
                options={dataSourceOptions}
                value={selectedDataSource}
                onChange={handleSelectChange}
                placeholder="Choose a data source..."
              />
            </dd>
          </div>
          {canEdit && (
            <div className="px-4 py-6 sm:grid sm:grid-cols-8 sm:gap-4 sm:px-0">
              <dt className="text-sm font-medium leading-6 text-gray-900">
                Upload File
              </dt>
              <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-3 sm:mt-0">
                <FileUpload connectionDataSourceId={selectedDataSource?.value} updateFileHistory={fetchFileHistory} />
              </dd>
            </div>
          )}
        </dl>
      </div>

      {fileHistory.length > 0 && <DataTable
        columns={columns}
        data={fileHistory}
        pagination
        highlightOnHover
        striped
        persistTableHead
      />}
      <p className="mt-2 text-xs text-gray-700">
        You can also forward emails with attachments to the email address <a className="text-primaryBrandColor hover:text-primaryBrandColor/80 underline cursor-pointer" href={`mailto:${organization?.primary_ingestion_address}`}>{organization?.primary_ingestion_address}</a>.
        <br />
        <br />
        To setup automated email forwarding from Gmail, please click <a href="#" className="text-primaryBrandColor hover:text-primaryBrandColor/80 underline cursor-pointer" onClick={handleSupportClick}>here</a> to contact support 
      </p>
    </div>

  );
}
